module.exports = __webpack_public_path__ + "static/media/plant-marker.4df741f1.svg";